import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody,
} from 'react-accessible-accordion'
import adicionarFiltroItinerario from '../../actions/itinerario/adicionarFiltroItinerario'
import removerFiltroItinerario from '../../actions/itinerario/removerFiltroItinerario'
import { FILTRO_IDS_ITINERARIOS } from '../../util/filtros'

export class FiltroIdsItinerarios extends Component {
  constructor(props) {
    super(props)
    this.state = { inputId: '' }
  }

  idsAdicionados() {
    return this.props.filtrosAdicionados.filter(f => f.chave === FILTRO_IDS_ITINERARIOS.chave)
  }

  adicionarId() {
    const valor = this.state.inputId.trim()
    if (!valor || isNaN(valor)) return

    const jaExiste = this.idsAdicionados().some(f => f.valor === valor)
    if (jaExiste) return

    this.props.adicionarFiltroItinerario({
      chave: FILTRO_IDS_ITINERARIOS.chave,
      label: FILTRO_IDS_ITINERARIOS.label,
      valor
    })
    this.setState({ inputId: '' })
  }

  handleKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault()
      this.adicionarId()
    }
  }

  render() {
    const ids = this.idsAdicionados()
    return (
      <Accordion>
        <AccordionItem expanded={true}>
          <AccordionItemTitle>
            <h6>{FILTRO_IDS_ITINERARIOS.label}</h6>
            <div className="accordion__arrow" role="presentation" />
          </AccordionItemTitle>
          <AccordionItemBody>
            <div className="row">
              <div className="col-10">
                <input
                  className="form-control"
                  type="number"
                  placeholder="Digite um ID..."
                  value={this.state.inputId}
                  onChange={e => this.setState({ inputId: e.target.value })}
                  onKeyDown={e => this.handleKeyDown(e)}
                />
              </div>
              <div className="col-2">
                <i
                  className="material-icons"
                  style={{ cursor: 'pointer' }}
                  onClick={() => this.adicionarId()}
                >
                  &#xe145;
                </i>
              </div>
            </div>
            {ids.length > 0 && (
              <div className="mt-2">
                {ids.map(f => (
                  <span
                    key={f.valor}
                    className="badge mr-1 mt-1"
                    style={{ backgroundColor: '#E6E6E6', fontSize: '13px' }}
                  >
                    {f.valor}
                    <span
                      className="badge badge-light ml-2 clicavel"
                      style={{ cursor: 'pointer' }}
                      onClick={() => this.props.removerFiltroItinerario(f)}
                    >
                      &times;
                    </span>
                  </span>
                ))}
              </div>
            )}
          </AccordionItemBody>
        </AccordionItem>
      </Accordion>
    )
  }
}

export const mapStateToProps = state => ({
  filtrosAdicionados: state.filtrosAdicionadosItinerario
})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltroItinerario,
    removerFiltroItinerario,
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroIdsItinerarios)
